import { List } from 'immutable';
import { STRING } from 'customer-data-objects/property/PropertyTypes';
import { isValidQuery } from 'customer-data-objects/search/ElasticSearchQuery';
import { makeOperator } from './Operator';
export default makeOperator({
  name: 'NotWildCardEqual',
  values: [{
    name: 'value',
    defaultValue: List(),
    isValid: (value, field) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    field.type === STRING && List.isList(value) && !value.isEmpty() && value.every(isValidQuery)
  }]
});